<template>
    <SidebarPanel
        :is-open="ui.notebook.opened"
        :title="localizations[lang].notebook"
        side="left"
        persistent
        mobile-fullscreen
        @close="toggleNotebook"
    >
        <template #toolbar>
            <Tabs />
        </template>

        <ReaderNoteAndHighlight v-show="showHighlightsAndNotes" />
        <ReaderHighlights v-show="ui.features.highlights.opened" />
        <ReaderNotes v-show="ui.features.notes.opened" />
    </SidebarPanel>
</template>

<script>
'use strict';

import { mapActions, mapGetters, mapState } from 'vuex';
import Tabs from './partials/Tabs.vue';
import ReaderNotes from './Tabs/ReaderNotes.vue';
import ReaderHighlights from './Tabs/ReaderHightlights.vue';
import ReaderNoteAndHighlight from './Tabs/ReaderNoteAndHighlight.vue';
import SidebarPanel from '../Components/SidebarPanel.vue';

export default {
    components: {
        Tabs,
        ReaderNotes,
        ReaderHighlights,
        ReaderNoteAndHighlight,
        SidebarPanel,
    },
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),
        ...mapGetters(['showHighlightsAndNotes']),
    },
    methods: {
        ...mapActions(['toggleNotebook']),
    },
};
</script>
